<div class="page">
  <header class="topbar">
    <div>
      <p class="eyebrow">Painel interno</p>
      <h1>Buscar atletas</h1>
    </div>
    <div style="display: flex; gap: 12px; align-items: center;">
      <a routerLink="/mfa-codes" class="ghost link-button">Códigos MFA</a>
      <button class="ghost" (click)="logout()">Sair</button>
    </div>
  </header>

  <section class="card">
    <form [formGroup]="form" (ngSubmit)="search()">
      <div class="filters">
        <label>
          <span>Nome ou apelido</span>
          <input type="text" formControlName="q" placeholder="Buscar" />
        </label>
        <label>
          <span>Gênero</span>
          <select formControlName="gender">
            <option value="">Todos</option>
            <option value="M">Masculino</option>
            <option value="F">Feminino</option>
          </select>
        </label>
        <label>
          <span>Categoria de peso</span>
          <select formControlName="weight_category">
            <option value="">Todas</option>
            <option *ngFor="let w of weightClasses" [value]="w">{{ w }}</option>
          </select>
        </label>
        <label>
          <span>País</span>
          <select formControlName="country">
            <option value="">Todos</option>
            <option *ngFor="let country of countries" [value]="country">{{ country }}</option>
          </select>
        </label>
        <label>
          <span>Estado</span>
          <select formControlName="state" (change)="onStateChange()">
            <option value="">Todos</option>
            <option *ngFor="let uf of states" [value]="uf">{{ uf }}</option>
          </select>
        </label>
        <label>
          <span>Cidade</span>
          <select formControlName="city" [disabled]="!cities.length">
            <option value="">{{ cities.length ? 'Todas' : 'Selecione o estado' }}</option>
            <option *ngFor="let c of cities" [value]="c">{{ c }}</option>
          </select>
        </label>
        <label>
          <span>Estreante</span>
          <select formControlName="is_rookie">
            <option value="">Todos</option>
            <option value="true">Sim</option>
            <option value="false">Não</option>
          </select>
        </label>
        <label>
          <span>Vitórias mín.</span>
          <input type="number" min="0" formControlName="victories_min" />
        </label>
        <label>
          <span>Vitórias máx.</span>
          <input type="number" min="0" formControlName="victories_max" />
        </label>
        <label>
          <span>Idade até</span>
          <input type="number" min="0" formControlName="age_max" />
        </label>
      </div>
      <div class="actions">
        <button type="button" class="ghost" (click)="resetFilters()">Limpar</button>
        <button type="submit" [disabled]="loading">Buscar</button>
      </div>
    </form>
  </section>

  <section class="list card">
    <div *ngIf="loading" class="feedback">Carregando atletas...</div>
    <div *ngIf="errorMessage" class="feedback error">{{ errorMessage }}</div>

    <div class="athlete" *ngFor="let athlete of athletes">
      <div class="athlete__header">
        <div>
          <p class="eyebrow">{{ athlete.gender === 'M' ? 'Masculino' : 'Feminino' }}</p>
          <h3>{{ athlete.full_name }}</h3>
          <p class="alias" *ngIf="athlete.fight_name">{{ athlete.fight_name }}</p>
        </div>
        <span class="badge" [class.badge--rookie]="athlete.is_rookie">
          {{ athlete.is_rookie ? 'Estreante' : 'Profissional' }}
        </span>
      </div>

      <div class="athlete__meta">
        <div>
          <small>Local</small>
          <p>{{ athlete.city || '-' }}, {{ athlete.state || '' }} {{ athlete.country || '' }}</p>
        </div>
        <div>
          <small>Peso</small>
          <p>{{ athlete.weight_category || '—' }}</p>
        </div>
        <div>
          <small>Idade</small>
          <p>{{ calculateAge(athlete.birth_date) !== null ? calculateAge(athlete.birth_date) + ' anos' : '—' }}</p>
        </div>
        <div>
          <small>Cartel</small>
          <p>{{ athlete.victories }}V / {{ athlete.defeats }}D / {{ athlete.draws }}E</p>
        </div>
      </div>

      <div class="links">
        <a *ngIf="athlete.tapology_link" [href]="athlete.tapology_link" target="_blank" rel="noreferrer">Tapology</a>
        <a *ngIf="athlete.sherdog_link" [href]="athlete.sherdog_link" target="_blank" rel="noreferrer">Sherdog</a>
        <a *ngIf="athlete.instagram" [href]="athlete.instagram" target="_blank" rel="noreferrer">Instagram</a>
      </div>

      <div *ngIf="athlete.notes" class="athlete__notes">
        <small>Observações</small>
        <p>{{ athlete.notes }}</p>
      </div>

      <div *ngIf="isAdmin" class="athlete__actions">
        <button type="button" class="ghost small" (click)="openEditModal(athlete)">Editar</button>
        <button type="button" class="ghost small danger" (click)="confirmDelete(athlete)" [disabled]="deletingAthleteId === athlete.id">
          {{ deletingAthleteId === athlete.id ? 'Excluindo...' : 'Excluir' }}
        </button>
      </div>
    </div>

    <div *ngIf="!loading && !athletes.length" class="feedback">Nenhum atleta encontrado.</div>

    <!-- Pagination -->
    <div *ngIf="pagination && pagination.last_page > 1" class="pagination">
      <div class="pagination__info">
        <span>
          Mostrando {{ (pagination.current_page - 1) * pagination.per_page + 1 }} a
          {{ Math.min(pagination.current_page * pagination.per_page, pagination.total) }} de
          {{ pagination.total }} atletas
        </span>
      </div>
      <div class="pagination__controls">
        <button
          type="button"
          class="ghost small"
          (click)="goToPage(pagination.current_page - 1)"
          [disabled]="pagination.current_page === 1 || loading">
          Anterior
        </button>
        <div class="pagination__pages">
          <button
            *ngFor="let page of getPageNumbers()"
            type="button"
            class="ghost small"
            [class.active]="page === pagination.current_page"
            (click)="goToPage(page)"
            [disabled]="loading">
            {{ page }}
          </button>
        </div>
        <button
          type="button"
          class="ghost small"
          (click)="goToPage(pagination.current_page + 1)"
          [disabled]="pagination.current_page === pagination.last_page || loading">
          Próxima
        </button>
      </div>
    </div>
  </section>

  <!-- Edit Modal -->
  <div *ngIf="showEditModal" class="modal-overlay" (click)="closeEditModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>Editar Atleta</h2>
        <button type="button" class="ghost small" (click)="closeEditModal()">×</button>
      </div>
      <form [formGroup]="editForm" (ngSubmit)="saveAthlete()">
        <div class="modal-body">
          <div class="form-grid">
            <label>
              <span>Nome completo *</span>
              <input type="text" formControlName="full_name" />
              <small *ngIf="editForm.get('full_name')?.touched && editForm.get('full_name')?.invalid">
                Nome é obrigatório
              </small>
            </label>
            <label>
              <span>Apelido</span>
              <input type="text" formControlName="fight_name" />
            </label>
            <label>
              <span>Data de nascimento</span>
              <input type="date" formControlName="birth_date" />
            </label>
            <label>
              <span>Gênero</span>
              <select formControlName="gender">
                <option value="">Selecione</option>
                <option value="M">Masculino</option>
                <option value="F">Feminino</option>
              </select>
            </label>
            <label>
              <span>Categoria de peso</span>
              <select formControlName="weight_category">
                <option value="">Selecione</option>
                <option *ngFor="let w of weightClasses" [value]="w">{{ w }}</option>
              </select>
            </label>
            <label>
              <span>País</span>
              <input type="text" formControlName="country" />
            </label>
            <label>
              <span>Estado</span>
              <select formControlName="state" (change)="onEditStateChange()">
                <option value="">Selecione</option>
                <option *ngFor="let uf of states" [value]="uf">{{ uf }}</option>
              </select>
            </label>
            <label>
              <span>Cidade</span>
              <select formControlName="city" [disabled]="!editCities.length">
                <option value="">{{ editCities.length ? 'Selecione' : 'Selecione o estado' }}</option>
                <option *ngFor="let c of editCities" [value]="c">{{ c }}</option>
              </select>
            </label>
            <label>
              <span>Estreante</span>
              <select formControlName="is_rookie">
                <option [value]="false">Não</option>
                <option [value]="true">Sim</option>
              </select>
            </label>
            <label>
              <span>Vitórias</span>
              <input type="number" min="0" formControlName="victories" />
            </label>
            <label>
              <span>Derrotas</span>
              <input type="number" min="0" formControlName="defeats" />
            </label>
            <label>
              <span>Empates</span>
              <input type="number" min="0" formControlName="draws" />
            </label>
            <label class="full-row">
              <span>Observações</span>
              <textarea formControlName="notes" maxlength="200" rows="4" placeholder="Observações sobre o atleta (opcional)"></textarea>
              <small class="char-counter">{{ (editForm.get('notes')?.value || '').length }}/200</small>
            </label>
            <label>
              <span>Link Tapology</span>
              <input type="url" formControlName="tapology_link" />
            </label>
            <label>
              <span>Link Sherdog</span>
              <input type="url" formControlName="sherdog_link" />
            </label>
            <label>
              <span>Instagram</span>
              <input type="text" formControlName="instagram" />
            </label>
            <label>
              <span>Telefone</span>
              <input type="text" formControlName="phone" />
            </label>
            <label>
              <span>E-mail</span>
              <input type="email" formControlName="email" />
            </label>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="ghost" (click)="closeEditModal()">Cancelar</button>
          <button type="submit" [disabled]="loading">Salvar</button>
        </div>
      </form>
    </div>
  </div>
</div>